import { createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, createVNode as _createVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3276a7da"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "quote-page" }
const _hoisted_2 = { class: "subscription-columns subscription-columns--cart-only" }
const _hoisted_3 = { class: "subscription-column subscription-column--in-progress" }
const _hoisted_4 = { class: "subscription-column-header" }
const _hoisted_5 = { class: "subscription-column-header-top" }
const _hoisted_6 = { class: "subscription-column-heading" }
const _hoisted_7 = ["href"]
const _hoisted_8 = { class: "subscription-column-subtitle" }
const _hoisted_9 = {
  key: 0,
  class: "quote-page-flags"
}
const _hoisted_10 = {
  key: 0,
  class: "subscription-card-badge quote-page-flag"
}
const _hoisted_11 = {
  key: 1,
  class: "subscription-card-badge quote-page-flag"
}
const _hoisted_12 = { class: "quote-page-parties" }
const _hoisted_13 = { class: "quote-page-party" }
const _hoisted_14 = {
  key: 0,
  class: "quote-page-reseller-logo"
}
const _hoisted_15 = ["src"]
const _hoisted_16 = { key: 1 }
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { class: "quote-page-label" }
const _hoisted_19 = { key: 1 }
const _hoisted_20 = { key: 2 }
const _hoisted_21 = ["href"]
const _hoisted_22 = { key: 3 }
const _hoisted_23 = {
  key: 3,
  class: "quote-page-party-contact"
}
const _hoisted_24 = { class: "quote-page-party" }
const _hoisted_25 = { key: 0 }
const _hoisted_26 = { key: 1 }
const _hoisted_27 = {
  key: 1,
  class: "quote-page-identity"
}
const _hoisted_28 = { class: "quote-page-text" }
const _hoisted_29 = { class: "subscription-column-body" }
const _hoisted_30 = { class: "subscription-column-cards" }
const _hoisted_31 = { class: "subscription-column-totals" }
const _hoisted_32 = { class: "total-row" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("sup", { class: "total-note-marker" }, "*", -1 /* HOISTED */))
const _hoisted_34 = { class: "total-row" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("sup", { class: "total-note-marker" }, "*", -1 /* HOISTED */))
const _hoisted_36 = { class: "total-row" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("sup", { class: "total-note-marker" }, "**", -1 /* HOISTED */))
const _hoisted_38 = { class: "subscription-column-vat-note" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("sup", { class: "total-note-marker" }, "*", -1 /* HOISTED */))
const _hoisted_40 = { class: "quote-page-actions" }
const _hoisted_41 = {
  key: 0,
  class: "quote-page-refusal"
}
const _hoisted_42 = {
  key: 1,
  class: "quote-page-refusal"
}
const _hoisted_43 = { class: "quote-page-buttons" }
const _hoisted_44 = ["disabled"]
const _hoisted_45 = ["disabled"]
const _hoisted_46 = ["disabled"]
const _hoisted_47 = ["disabled"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createCommentVNode(" One column, laid out as the cart's lone column (subscription-columns--cart-only) and\n\t\t     coloured as \"Your orders in progress\", which this page mirrors: its header is the quote's. "),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("h2", _hoisted_6, _toDisplayString(_ctx.__("Quote number: {0}", [$setup.quote.name])), 1 /* TEXT */),
            _createElementVNode("a", {
              href: $props.page.list_url,
              class: "subscription-column-continue"
            }, _toDisplayString(_ctx.__("Back to My Quotes")), 9 /* TEXT, PROPS */, _hoisted_7)
          ]),
          _createElementVNode("p", _hoisted_8, [
            _createTextVNode(_toDisplayString(_ctx.__("Quote date: {0}", [$setup.quote.quote_date])) + " ", 1 /* TEXT */),
            ($setup.quote.valid_until)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createTextVNode(" · " + _toDisplayString(_ctx.__("Valid until: {0}", [$setup.quote.valid_until])), 1 /* TEXT */)
                ], 64 /* STABLE_FRAGMENT */))
              : _createCommentVNode("v-if", true)
          ]),
          ($setup.quote.outdated || $setup.quote.inactive)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                ($setup.quote.outdated)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(_ctx.__("Out dated quote")), 1 /* TEXT */))
                  : _createCommentVNode("v-if", true),
                ($setup.quote.inactive)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(_ctx.__("Inactive")), 1 /* TEXT */))
                  : _createCommentVNode("v-if", true)
              ]))
            : _createCommentVNode("v-if", true),
          _createCommentVNode(" The reseller's block, then the customer's, each as an address is written: its heading, the\n\t\t\t\t\t     company, its contact, a line left out when it has nothing to show. The reseller's has the\n\t\t\t\t\t     lines of the order confirmation's reseller frame (quotes.get_reseller_details), none for\n\t\t\t\t\t     \"I choose later\". Side by side on a wide screen, the reseller's first when they stack. "),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("dl", _hoisted_13, [
              _createElementVNode("dt", null, _toDisplayString(_ctx.__("Reseller")), 1 /* TEXT */),
              ($setup.quote.reseller_details && $setup.quote.reseller_details.logo)
                ? (_openBlock(), _createElementBlock("dd", _hoisted_14, [
                    _createElementVNode("img", {
                      src: $setup.quote.reseller_details.logo,
                      alt: "",
                      loading: "lazy"
                    }, null, 8 /* PROPS */, _hoisted_15)
                  ]))
                : _createCommentVNode("v-if", true),
              ($setup.quote.reseller_name)
                ? (_openBlock(), _createElementBlock("dd", _hoisted_16, _toDisplayString($setup.quote.reseller_name), 1 /* TEXT */))
                : _createCommentVNode("v-if", true),
              ($setup.quote.reseller_details)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.quote.reseller_details.address_lines, (line, index) => {
                      return (_openBlock(), _createElementBlock("dd", { key: index }, _toDisplayString(line), 1 /* TEXT */))
                    }), 128 /* KEYED_FRAGMENT */)),
                    ($setup.quote.reseller_details.vat_number)
                      ? (_openBlock(), _createElementBlock("dd", _hoisted_17, [
                          _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.__("VAT number")), 1 /* TEXT */),
                          _createTextVNode(" " + _toDisplayString($setup.quote.reseller_details.vat_number), 1 /* TEXT */)
                        ]))
                      : _createCommentVNode("v-if", true),
                    ($setup.quote.reseller_details.email)
                      ? (_openBlock(), _createElementBlock("dd", _hoisted_19, _toDisplayString($setup.quote.reseller_details.email), 1 /* TEXT */))
                      : _createCommentVNode("v-if", true),
                    ($setup.quote.reseller_details.website)
                      ? (_openBlock(), _createElementBlock("dd", _hoisted_20, [
                          ($setup.quote.reseller_details.website.href)
                            ? (_openBlock(), _createElementBlock("a", {
                                key: 0,
                                href: $setup.quote.reseller_details.website.href,
                                target: "_blank",
                                rel: "noopener noreferrer"
                              }, _toDisplayString($setup.quote.reseller_details.website.label), 9 /* TEXT, PROPS */, _hoisted_21))
                            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                _createTextVNode(_toDisplayString($setup.quote.reseller_details.website.label), 1 /* TEXT */)
                              ], 64 /* STABLE_FRAGMENT */))
                        ]))
                      : _createCommentVNode("v-if", true),
                    ($setup.quote.reseller_details.phone)
                      ? (_openBlock(), _createElementBlock("dd", _hoisted_22, _toDisplayString($setup.quote.reseller_details.phone), 1 /* TEXT */))
                      : _createCommentVNode("v-if", true)
                  ], 64 /* STABLE_FRAGMENT */))
                : _createCommentVNode("v-if", true),
              ($setup.quote.reseller_contact_line)
                ? (_openBlock(), _createElementBlock("dd", _hoisted_23, _toDisplayString($setup.quote.reseller_contact_line), 1 /* TEXT */))
                : _createCommentVNode("v-if", true)
            ]),
            _createElementVNode("dl", _hoisted_24, [
              _createElementVNode("dt", null, _toDisplayString(_ctx.__("Customer")), 1 /* TEXT */),
              ($setup.quote.enduser_name)
                ? (_openBlock(), _createElementBlock("dd", _hoisted_25, _toDisplayString($setup.quote.enduser_name), 1 /* TEXT */))
                : _createCommentVNode("v-if", true),
              ($setup.quote.customer_contact_line)
                ? (_openBlock(), _createElementBlock("dd", _hoisted_26, _toDisplayString($setup.quote.customer_contact_line), 1 /* TEXT */))
                : _createCommentVNode("v-if", true)
            ])
          ]),
          ($setup.quote.personal_info)
            ? (_openBlock(), _createElementBlock("dl", _hoisted_27, [
                _createElementVNode("div", null, [
                  _createElementVNode("dt", null, _toDisplayString(_ctx.__("Text")), 1 /* TEXT */),
                  _createElementVNode("dd", _hoisted_28, _toDisplayString($setup.quote.personal_info), 1 /* TEXT */)
                ])
              ]))
            : _createCommentVNode("v-if", true)
        ]),
        _createElementVNode("div", _hoisted_29, [
          _createElementVNode("div", _hoisted_30, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.groups, (group) => {
              return (_openBlock(), _createElementBlock(_Fragment, {
                key: group.key
              }, [
                _createVNode($setup["CartCategories"], {
                  category: group.family,
                  start_date: ""
                }, null, 8 /* PROPS */, ["category"]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.items, (item) => {
                  return (_openBlock(), _createBlock($setup["SubscriptionCard"], {
                    key: item.name,
                    item: item,
                    users: $setup.users,
                    readonly: true,
                    quote: true,
                    variable_price_marker: true
                  }, null, 8 /* PROPS */, ["item", "users"]))
                }), 128 /* KEYED_FRAGMENT */))
              ], 64 /* STABLE_FRAGMENT */))
            }), 128 /* KEYED_FRAGMENT */))
          ]),
          _createCommentVNode(" The quote's totals as the server made them (ioisysQuoteSubscription.calculate_totals):\n\t\t\t\t\t     its Inactive lines left out. "),
          _createElementVNode("div", _hoisted_31, [
            _createElementVNode("div", _hoisted_32, [
              _createElementVNode("h6", null, [
                _createTextVNode(_toDisplayString(_ctx.__("Total Setup and Purchase")), 1 /* TEXT */),
                _hoisted_33
              ]),
              _createElementVNode("h6", null, _toDisplayString($setup.ioi_format_currency($setup.quote.setup_total_in_quote || 0.0, $setup.quote.currency)), 1 /* TEXT */)
            ]),
            _createElementVNode("div", _hoisted_34, [
              _createElementVNode("h6", null, [
                _createTextVNode(_toDisplayString(_ctx.__("Total Subscription")), 1 /* TEXT */),
                _hoisted_35
              ]),
              _createElementVNode("h6", null, _toDisplayString($setup.ioi_format_currency($setup.quote.subscription_total_in_quote || 0.0, $setup.quote.currency)), 1 /* TEXT */)
            ]),
            _createElementVNode("div", _hoisted_36, [
              _createElementVNode("h6", null, [
                _createTextVNode(_toDisplayString(_ctx.__("Setup time")), 1 /* TEXT */),
                _hoisted_37
              ]),
              _createElementVNode("h6", null, _toDisplayString($setup.quote.setup_time_in_quote || 0) + " " + _toDisplayString(_ctx.__("Hours")), 1 /* TEXT */)
            ]),
            _createElementVNode("p", _hoisted_38, [
              _createTextVNode(_toDisplayString(_ctx.__("Prices exclude VAT")), 1 /* TEXT */),
              _hoisted_39
            ]),
            _createVNode($setup["SetupTimeFootnote"], { subscription_items: $setup.counted_items }, null, 8 /* PROPS */, ["subscription_items"])
          ]),
          _createElementVNode("div", _hoisted_40, [
            (!$props.page.can_push)
              ? (_openBlock(), _createElementBlock("p", _hoisted_41, _toDisplayString($props.page.push_refusal), 1 /* TEXT */))
              : _createCommentVNode("v-if", true),
            ($props.page.send_to_customer && $props.page.send_to_customer.refusal)
              ? (_openBlock(), _createElementBlock("p", _hoisted_42, _toDisplayString($props.page.send_to_customer.refusal), 1 /* TEXT */))
              : _createCommentVNode("v-if", true),
            _createElementVNode("div", _hoisted_43, [
              ($props.page.can_download)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    type: "button",
                    class: "btn btn-default",
                    disabled: $setup.busy,
                    onClick: $setup.download_pdf
                  }, _toDisplayString(_ctx.__("Download PDF")), 9 /* TEXT, PROPS */, _hoisted_44))
                : _createCommentVNode("v-if", true),
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-default",
                disabled: $setup.busy,
                onClick: $setup.delete_quote
              }, _toDisplayString(_ctx.__("Delete Quote")), 9 /* TEXT, PROPS */, _hoisted_45),
              _createCommentVNode(" In a focus alone (www/my_quotes.get_send_to_customer): the quote mailed to the focused contact again. "),
              ($props.page.send_to_customer)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 1,
                    type: "button",
                    class: "btn btn-default",
                    disabled: $setup.busy || !!$props.page.send_to_customer.refusal,
                    onClick: $setup.mail_to_customer
                  }, _toDisplayString(_ctx.__("Send to the customer")), 9 /* TEXT, PROPS */, _hoisted_46))
                : _createCommentVNode("v-if", true),
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-primary",
                disabled: $setup.busy || !$props.page.can_push,
                onClick: $setup.push_to_basket
              }, _toDisplayString(_ctx.__("Push to basket")), 9 /* TEXT, PROPS */, _hoisted_47)
            ])
          ])
        ])
      ])
    ])
  ]))
}